import { useQuery } from '@tanstack/react-query';
import { apiUrlGenerator } from 'infrastructure/hooks/use-api';
import dataService from 'services/dataService';

import type { IGetPatientReportsResponse } from 'components/organisms/provider-dashboard';

export interface IGetProviderDashboardPatientReportsFilters {
  startDate: string;
  endDate: string;
  clinicGuid?: string[];
  parentClinicGuid?: string[];
  providerGuid?: string;
}

const url = 'core-2/provider-dashboard/patient-reports';

export const getProviderDashboardPatientReportsQueryKey = (
  filters: IGetProviderDashboardPatientReportsFilters,
) => [url, filters] as const;

const queryFn = async (filters: IGetProviderDashboardPatientReportsFilters) => {
  const { data, error } = await dataService.getList<IGetPatientReportsResponse>(
    apiUrlGenerator(url, filters),
  );

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useGetProviderDashboardPatientReports = (
  filters: IGetProviderDashboardPatientReportsFilters,
  enabled = true,
) => {
  const queryKey = getProviderDashboardPatientReportsQueryKey(filters);

  const { data, isLoading, isFetching } = useQuery<
    IGetPatientReportsResponse | undefined,
    string | undefined
  >({
    queryKey,
    queryFn: async () => queryFn(filters),
    keepPreviousData: true,
    enabled,
  });

  return {
    patientReports: data,
    isLoading,
    isFetching,
  };
};
